<template>
  <div class="details">
    <HeaderNav :current="current"></HeaderNav>
    <div class="news-content w1200">
      <div class="text">
        <!-- <p>首页/新闻</p> -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ name: 'TopTeacherList'}"><a href="javascript:void(0);">名师列表</a></el-breadcrumb-item>
          <el-breadcrumb-item>名师详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- <h2 class="clum">
        <i class="icon">活动信息</i>
      </h2> -->
      <div class="left-item">
        <el-card :body-style="{ padding: '10px', overflow: 'hidden' }">
          <div class="cover">
            <img :src="teacherInfo.headImg" alt="">
          </div>
          <div class="item-content">
            <p class="title">姓名：{{teacherInfo.teacherName}}</p>
            <p class="subtitle">性别：{{teacherInfo.sex === 1?'男':'女'}}</p>
            <p class="time">出生日期：{{formatDate(teacherInfo.birthday)}}</p>
            <p class="time">所属机构：{{teacherInfo.mechanismName}}</p>
            <div class="desc">简介：{{teacherInfo.briefDesc}}</div>
          </div>
        </el-card>
        <!-- <span>查看详情</span> -->
      </div>
      <div class="action-msg">
        <!-- <div class="video" v-if="newDetails.videoUrl">
          <video controls :src="newDetails.videoUrl"></video>
        </div> -->
        <div class="content" ref="content" v-html="newDetails"></div>
      </div>
    </div>
    <BackTop></BackTop>
    <CopyRight></CopyRight>
  </div>
</template>

<script>
import { getDetailContent } from '@/api/association'
import HeaderNav from '@/components/common/HeaderNav/HeaderNav'
import CopyRight from '@/components/common/CopyRight/CopyRight'
import BackTop from '@/components/common/BackTop/BackTop'
import {formatDate} from '@/components/common/config/formatTime.js'
export default {
  name: 'tabs',
  components: {
    HeaderNav,
    CopyRight,
    BackTop
  },
  data () {
    return {
      current: 3,
      newDetails: {},
      teacherInfo: JSON.parse(this.$route.query.item),
      list: [],
      pageNum: 1,
      sliderStyle: {
        width: '100%'
      }
    }
  },
  methods: {
    formatDate,
    getDetailContent () {
      let that = this
      getDetailContent({ id: that.teacherInfo.id }).then(res => {
        if (res.data.status === 0) {
          that.newDetails = res.data.data
          // console.log(res.data.data)
          that.$nextTick(function () {
            that.reverPptUrl()
          // Code that will run only after the
          // entire view has been rendered
          })
        }
      })
      // that.loading = true
    },

    // ppt添加缩略图样式
    reverPptUrl: function () {
      let pptArr = this.$refs.content.getElementsByTagName('img')
      if (pptArr.length > 0) {
        console.log(pptArr.length)
        for (let i = 0; i < pptArr.length; i++) {
        // let pptEl = pptArr[i].src
          let NewPptUrl = 'width:100%;display:block;'
          pptArr[i].setAttribute('style', NewPptUrl)
        // console.log(NewPptUrl)
        }
      }
    }
  },
  mounted () { // 这里必须是mouted钩子
  },
  created () {
    this.getDetailContent()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .details {
    width: 100%;
    background-color: #fff;
  }

  .news-content {
    width: 1100px;
    padding: 20px 50px 50px 50px;
    background: #f3f3f3;
    border-radius: 10px;
    margin-top: 20px;
  }

  .clum {
    overflow: hidden;
    padding: 35px 0px;
  }

  .clum .icon {
    float: left;
    font-size: 24px;
    font-weight: bold;
    background-position: 0px center;
    background-repeat: no-repeat;
    background-size: 5px 24px;
    background-image: url(../../../static/images/nwe-shuxian.png);
    padding-left: 14px;
    font-style: normal;
  }

  .clum span {
    float: right;
    font-size: 16px;
    color: #888;
    line-height: 30px;
    cursor: pointer;
  }
  .left-item {
    width: 100%;
    background: #fff;
    padding: 10px 10px;
    border-bottom: 1px solid #f3f3f3;
    overflow: hidden;
    box-sizing: border-box;
  }
  .left-item .cover{
    /* width: 107px;
    height: 60px; */
    margin-right: 10px;
    float: left;
  }
  .left-item .cover img{
    display: block;
    height:170px;
  }
  .item-content{
    width:calc(100% - 157px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    float: left;
  }
  .left-item p {
    font-size:16px;
    color:#1a1919;
    overflow: hidden;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .left-item .title{
    font-size: 16px;
    color:#1a1919;
    font-weight: 600;
  }
  .left-item .subtitle{
    font-size: 16px;
    color:#666;
    margin-top:10px;
  }
  .left-item .time{
    font-size: 16px;
    color:#666;
     margin-top:10px;
  }
  .left-item .desc{
    font-size: 16px;
    color:#666;
    margin-top:10px;
    white-space: normal ;
  }
  .left-item span{
    color: #999;
    font-size: 16px;
  }
  .left-item:nth-child(2n) {
    border-left: 1px solid #f3f3f3;
  }
  .text {
    border-radius: 5px;
    background: #fff;
    margin-top: 30px;
    padding: 20px 10px;
    border-bottom: 1px solid #f6f6f6;
  }
  .text p {
    font-size: 14px;
    color:#888;
    padding: 15px;
  }
  .action-msg{
    width: 100%;
    background: #fff;
    padding: 10px 10px;
    box-sizing: border-box;
  }
  .action-msg .content img{
    display: block;
    width: 100%!important;
  }
  .details-title{
    width: 100%;
    text-align: left;
    padding: 10px 0px;
  }
  .details-title p:first-child{
    font-size: 16px;
    color:#333;
  }
  .details-title p:nth-child(2){
    font-size: 14px;
    color:#666;
    margin-top: 5px;
  }
  .details-title p:nth-child(3){
    font-size: 12px;
    color:#999;
    margin-top: 5px;
  }
  .video {
    width: 100%;
    margin-bottom: 10px;

  }
  .video video{
    display: block;
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/topTeacher/TeacherDetails.vue